import PropTypes from 'prop-types';
import {
  AboutContainer,
  About,
  AboutTitle,
  AboutContent,
  AboutContentImg,
  AboutImage,
  AboutWrapper,
  AboutSheild,
  AboutContentGroup,
  AboutSubTitle
} from './styles';

const AboutUnacademy = ({ features, featuresBg }) => {
  const { title, resources } = features;
  return (
    <AboutContainer>
      <AboutWrapper>
        <AboutSheild>
          <About>
            <AboutTitle>{title}</AboutTitle>
          </About>
          <AboutContentGroup>
            {resources.map((_resource) => (
              <AboutSubTitle key={_resource.id}>
                <AboutContentImg
                  src={_resource.url.default}
                  alt={_resource.title}
                  width="20px"
                  height="20px"
                />
                <AboutContent>{_resource.title}</AboutContent>
              </AboutSubTitle>
            ))}
          </AboutContentGroup>
          <AboutImage
            src={featuresBg}
            alt="about image"
            width="auto"
            height="164px"
          />
        </AboutSheild>
      </AboutWrapper>
    </AboutContainer>
  );
};

AboutUnacademy.propTypes = {
  features: PropTypes.objectOf(PropTypes.any).isRequired,
  featuresBg: PropTypes.string.isRequired
};

export default AboutUnacademy;
